export default __webpack_public_path__ + "static/logo_4-3755a8596a417d4afa933829de9db7c5.jpg";